import { LOCALES } from "../constants";

const txt = {
    [LOCALES.ENGLISH]: {
        "menu-locations": "Ireland, France, Germany, England",
        hello: "Hello",
        "menu-properties": "Properties",
        "menu-contact": "Contact",
        "menu-search": "Search",
        "menu-connect-button": "Connect MetaMask",
        "home-banner-sales-rep": "Real state official agent",
        "home-banner-ideal-home": "The best house for the best moment",
        "home-banner-help-you":
            "We'll help you find the precise house you're looking for.",
        "home-banner-see-propperties": "See properties",
        "search-section-where": "Where to look?",
        "search-operation-type": "Listing Status",
        "search-operation-rental": "Rent",
        "search-operation-temporary-rental": "Temporary rental",
        "search-property-type": "Property Type",
        "search-property-apartment": "Apartament",
        "search-property-home": "Home",
        "search-property-vila": "Vila",
        "search-property-office": "Office",
        "more-recent": "More recent",
        properties: "Properties",
        "product-listing-see-all": "See all",
        "footer-slogan":
            "We'll help you find the precise house you're looking for.",
        "footer-project": "Project",
        "footer-properties": "See the properties",
        "footer-us": "About us",
        "footer-contact": "Contact",
        "footer-terms": "Terms and conditions",
        "footer-customer-service": "Customer service",
        "footer-add-listing": "Add property",
        "home-page": "Home",
        "page-nosotros-header": "Who we are?",
        "page-404": "404 Page",
        "page-myaccount-header": "My account",
        "my-account-profile": "My profile",
        "myaccount-register-account": "Register Account",
        "myaccount-personal-data": "Personal data",
        "myaccount-my-properties": "My Properties NFT",
        "myaccount-property-bookings": "Property Bookings",
        "myaccount-add-properties": "Add Property",
        "myaccount-rewards": "Rewards",
        "myaccount-agent-label": "Real state agent",
        "myaccount-profile-edit": "Edit your profile",
        "myaccount-profile-name": "Name",
        "myaccount-profile-lastname": "Lastname",
        "myaccount-profile-country": "Country",
        "myaccount-profile-save-changes": "Save changes",
        "myaccount-my-props-title": "My Properties",
        "myaccount-my-props-date": "Date added",
        "myaccount-my-props-list-property": "List Property",
        "myaccount-history-property": "Property",
        "myaccount-history-date": "Date added",
        "myaccount-history-actions": "Actions",
        "myaccount-history-delete": "Delete",
        "myaccount-add-property-page-title": "Add new property",
        "myaccount-add-property-details-title": "Details of the property",
        "myaccount-add-property-title-field": "Title*",
        "myaccount-add-property-description-field": "Description",
        "myaccount-add-property-price-field": "Price",
        "myaccount-add-property-category-field": "Category",
        "myaccount-add-property-pictures-field": "Pictures",
        "myaccount-add-property-pictures-comments-1":
            "* Enter at least one image larger than 500x500px.",
        "myaccount-add-property-pictures-comments-2":
            "* PDF files can be uploaded.",
        "myaccount-add-property-pictures-comments-3":
            "* Images may take time to process.",
        "myaccount-add-property-location-title": "Location",
        "myaccount-add-property-address-field": "Address*",
        "myaccount-add-property-country-field": "Country",
        "myaccount-add-property-city-field": "City",
        "myaccount-add-property-state-field": "State / District",
        "myaccount-add-property-lat-field": "Latitud (Google Maps)",
        "myaccount-add-property-lon-field": "Longitud (Google Maps)",
        "myaccount-add-property-load-automatically":
            "Load location automatically",
        "myaccount-add-property-rooms-field": "Rooms*",
        "myaccount-add-property-size-field": "Size (m2)",
        "myaccount-add-property-bathrooms-field": "Bathrooms",
        "myaccount-add-property-garages-field": "Garages",
        "myaccount-add-property-basement-field": "Basement",
        "myaccount-add-property-balcony-field": "Balcony",
        "myaccount-add-property-save-button": "Save property",
        "myaccount-add-property-select": "Select the category",
        "myaccount-rewards-send-button": "Send",
        "myaccount-rewards-receive-button": "Receive",
        "myaccount-rewards-rewards-history": "Rewards history",
        "myaccount-rewards-badges": "Badges",
        "page-properties-header": "Propiedades",
        "properties-sort-by": "Sort by:",
        "properties-price": "Price",
        "properties-more-recent": "More recent",
        "properties-popular": "Popular",
        "properties-filter": "Filter...",
        "properties-helper-accept-location":
            "In order to see the properties nerby, you must accept sharing location with the page",
        "properties-helper-connected-network":
            "There are not properties yet, please check you are connected to tie right network in metamask",
        "properties-rent": "Rent",
        "properties-rooms": "Rooms",
        "properties-month": "Month",
        "properties-information-title": "Information",
        "properties-type-title": "Type of property",
        "properties-house": "House",
        "properties-apartment": "Apartment",
        "properties-office": "Office",
        "properties-duplex": "Duplex",
        "properties-industrial": "Industrial",
        "properties-filter-price": "Filter by price",
        "properties-categories": "Categories",
        "property-details-header": "Property details",
        "property-details-featured-badge": "Featured",
        "property-details-rent-badge": "Rent",
        "property-details-comments": "Comments",
        "property-details-rent-now": "Rent now",
        "property-details-confirm-landlord": "Confirm rent as landlord",
        "property-details-confirm-tenant": "Confirm rent as tenant",
        "property-details-rooms": "Rooms",
        "property-details-description": "Description",
        "property-details-badges-agent": "Badges from the agent",
        "property-details-badges-property": "Badges from the property",
        "property-details-no-badges": "This property has no badges yet",
        "property-details-real-state-agent": "Real state agent",
        "property-details-seller-description": "Seller in Bonvo for 15 years.",
        "property-details-location": "Location",
        "property-details-reviews": "Reviews",
        "page-contact-header": "Contact",
        "page-contact-contact-email": "Contact",
        "page-contact-phone": "Phone",
        "page-contact-contact-us": "Contact us",
        "page-contact-type": "Type of consultation",
        "page-contact-home-rental": "Home rental",
        "page-contact-property-management": "Property management",
        "page-contact-resolve-conflict": "Resolve conflict",
        "page-contact-others": "Others",
        "page-contact-store-data": "Store my data for future questions",
        "page-contact-send-question": "Send",
        "page-contact-insert-name": "Enter your name",
        "page-contact-insert-email": "Enter your email",
        "page-contact-insert-phone": "Enter your phone",
        "page-contact-write-message": "Write your message",
    },
};

export default txt;
